// src/utils/apiBase.js
// Normalize API base so callers can append "/api/...".
// - Localhost dev should not use "/backend" prefix.
// - Production may need "/backend".
const rawBase = (process.env.REACT_APP_API_BASE || "").trim().replace(/\/+$/, "");

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

let API_BASE = rawBase;
if (isLocalHost) {
  API_BASE = API_BASE.replace(/\/backend(?=\/|$)/i, "");
}

API_BASE = API_BASE.replace(/\/api$/i, "");

export default API_BASE;
